import PERMISSIONS from "@/common/permissions-lib";

export default {
	path: "/Help",
	component: () =>
		import(/* webpackChunkName: "User" */ "@/views/Help/HelpMain"),
	meta: {
		breadcrumb: "Help",
		authorizedRoles: [PERMISSIONS.HELP_VIEW]
	}
};
